import { ACTIVITY } from "./enums";
import { saveAs } from "file-saver";

// Get authorization token from stored user data
export const getAuthorizationToken = () => {
  try {
    const googleLoginUser = localStorage.getItem("googleLoginUser");
    if (googleLoginUser) {
      const userData = JSON.parse(googleLoginUser);
      return userData.authorizationToken || null;
    }
    return null;
  } catch (error) {
    console.error("Error getting authorization token:", error);
    return null;
  }
};

// Refresh authorization token and update stored user data
export const refreshAuthorizationToken = async (user) => {
  try {
    if (user) {
      const idToken = await user.getIdToken();
      const googleLoginUser = localStorage.getItem("googleLoginUser");
      if (googleLoginUser) {
        const userData = JSON.parse(googleLoginUser);
        userData.authorizationToken = idToken;
        localStorage.setItem("googleLoginUser", JSON.stringify(userData));
      }
      return idToken;
    }
    return null;
  } catch (error) {
    console.error("Error refreshing authorization token:", error);
    return null;
  }
};

export const socialMediaData = [
  {
    name: "LinkedIn",
    apiName: "linkedin",
    icon: "https://img.icons8.com/color/48/linkedin.png",
    host: "https://www.linkedin.com/company/",
    iconWhite: "https://img.icons8.com/ios/50/FFFFFF/linkedin.png",
    iconBlack: "https://img.icons8.com/ios/50/1A1A1A/linkedin.png",
    iconWhiteFill: "https://img.icons8.com/ios-glyphs/60/FFFFFF/linkedin.png",
    iconBlackFill: "https://img.icons8.com/ios-glyphs/60/1A1A1A/linkedin.png",
    activity: ACTIVITY.LINKEDIN_VISIT,
    text: "Follow",
  },
  {
    name: "Facebook",
    apiName: "fb_link",
    icon: "https://img.icons8.com/color/48/null/facebook-new.png",
    iconWhite: "https://img.icons8.com/ios/50/FFFFFF/facebook-new.png",
    iconBlack: "https://img.icons8.com/ios/50/1A1A1A/facebook-new.png",
    iconWhiteFill:
      "https://img.icons8.com/ios-glyphs/60/FFFFFF/facebook-new.png",
    iconBlackFill:
      "https://img.icons8.com/ios-glyphs/60/1A1A1A/facebook-new.png",
    host: "https://www.facebook.com/",
    activity: ACTIVITY.FB_VISIT,
    text: "Follow",
  },
  {
    name: "Instagram",
    apiName: "insta_link",
    icon: "https://img.icons8.com/color/48/null/instagram-new--v1.png",
    iconWhite: "https://img.icons8.com/ios/50/FFFFFF/instagram-new--v1.png",
    iconBlack: "https://img.icons8.com/ios/50/1A1A1A/instagram-new--v1.png",
    iconWhiteFill:
      "https://img.icons8.com/ios-glyphs/60/FFFFFF/instagram-new.png",
    iconBlackFill:
      "https://img.icons8.com/ios-glyphs/60/1A1A1A/instagram-new.png",
    host: "https://instagram.com/",
    activity: ACTIVITY.INSTA_VISIT,
    text: "Follow",
  },

  {
    name: "Youtube",
    apiName: "youtube_link",
    icon: "https://img.icons8.com/color/48/youtube-play.png",
    iconWhite: "https://img.icons8.com/ios/50/FFFFFF/youtube-play--v1.png",
    iconBlack: "https://img.icons8.com/ios/50/1A1A1A/youtube-play--v1.png",
    iconWhiteFill:
      "https://img.icons8.com/ios-glyphs/60/FFFFFF/youtube-play.png",
    iconBlackFill:
      "https://img.icons8.com/ios-glyphs/60/1A1A1A/youtube-play.png",
    host: "https://www.youtube.com/@",
    activity: ACTIVITY.YOUTUBE_VISIT,
    text: "Subscribe",
  },

  {
    name: "WhatsApp",
    apiName: "whatsapp",
    icon: "https://img.icons8.com/color/48/whatsapp.png",
    iconWhite:
      "https://img.icons8.com/fluency-systems-regular/48/FFFFFF/whatsapp--v1.png",
    iconBlack:
      "https://img.icons8.com/fluency-systems-regular/48/1A1A1A/whatsapp--v1.png",
    iconWhiteFill: "https://img.icons8.com/ios-glyphs/60/FFFFFF/whatsapp.png",
    iconBlackFill: "https://img.icons8.com/ios-glyphs/60/1A1A1A/whatsapp.png",
    host: "https://wa.me/",
    activity: ACTIVITY.WA_VISIT,
    text: "Chat",
  },

  {
    name: "Twitter",
    apiName: "twitter",
    icon: "https://img.icons8.com/ios-filled/100/twitterx--v1.png",
    iconWhite: "https://img.icons8.com/ios/50/FFFFFF/twitterx--v2.png",
    iconBlack: "https://img.icons8.com/ios/50/1A1A1A/twitterx--v2.png",
    iconWhiteFill:
      "https://img.icons8.com/ios-filled/100/FFFFFF/twitterx--v2.png",
    iconBlackFill:
      "https://img.icons8.com/ios-filled/100/1A1A1A/twitterx--v2.png",
    host: "https://x.com/",
    activity: ACTIVITY.X_VISIT,
    text: "Follow",
  },

  {
    name: "Snapchat",
    apiName: "snapchat",
    icon: "https://img.icons8.com/fluency/48/snapchat.png",
    iconWhite: "https://img.icons8.com/ios/50/FFFFFF/snapchat--v1.png",
    iconBlack: "https://img.icons8.com/ios/50/1A1A1A/snapchat--v1.png",
    iconWhiteFill:
      "https://img.icons8.com/ios-filled/100/FFFFFF/snapchat--v1.png",
    iconBlackFill:
      "https://img.icons8.com/ios-filled/100/1A1A1A/snapchat--v1.png",
    host: "https://www.snapchat.com/add/",
    activity: ACTIVITY.SNAP_VISIT,
    text: "Add",
  },
  {
    name: "TikTok",
    apiName: "tiktok",
    icon: "https://img.icons8.com/ios-filled/100/tiktok--v1.png",
    iconWhite: "https://img.icons8.com/ios/50/FFFFFF/tiktok--v1.png",
    iconBlack: "https://img.icons8.com/ios/50/1A1A1A/tiktok--v1.png",
    iconWhiteFill: "https://img.icons8.com/ios-glyphs/60/FFFFFF/tiktok.png",
    iconBlackFill: "https://img.icons8.com/ios-glyphs/60/1A1A1A/tiktok.png",
    host: "https://vm.tiktok.com/",
    activity: ACTIVITY.TIKTOK_VISIT,
    text: "Follow",
  },
  {
    name: "Website",
    apiName: "website",
    icon: "https://img.icons8.com/fluency/48/internet.png",
    iconWhite: "https://img.icons8.com/ios/50/FFFFFF/globe--v1.png",
    iconBlack: "https://img.icons8.com/ios/50/1A1A1A/globe--v1.png",
    iconWhiteFill: "https://img.icons8.com/ios-filled/100/FFFFFF/globe--v1.png",
    iconBlackFill: "https://img.icons8.com/ios-filled/100/1A1A1A/globe--v1.png",
    host: "https://",
    activity: ACTIVITY.WEBSITE_VISIT,
    text: "Visit",
  },
];

export const makeHyperLinks = (brandingData) => {
  socialMediaData.forEach((sm) => {
    const userInput = brandingData[sm.apiName];
    if (userInput && !userInput.includes("http")) {
      brandingData[sm.apiName] = sm.host + userInput;
    }
  });
};

export const makeHyperLink = (link, host) => {
  var newLink = link;
  if (link && !link.includes("http")) {
    newLink = host + link;
  }
  return newLink;
};

export const handleOpenLink = (username, host, activity, handleActivity) => {
  const href = makeHyperLink(username, host);
  if (handleActivity) handleActivity(activity);
  window.open(href, "_blank");
};

const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

// Module-level lock to prevent concurrent navigator.share calls
let navigatorShareLock = false;
let navigatorShareQueue = [];

const processShareQueue = async () => {
  // Process queue only if lock is free and queue has items
  if (navigatorShareLock || navigatorShareQueue.length === 0) {
    return;
  }

  const { shareData, resolve, reject } = navigatorShareQueue.shift();
  navigatorShareLock = true;

  try {
    await navigator.share(shareData);
    resolve();
  } catch (err) {
    reject(err);
  } finally {
    navigatorShareLock = false;
    // Process next item in queue after current share completes
    processShareQueue();
  }
};

export const handleSaveImage = async (
  url,
  name,
  mimeType,
  setNavigatorShareInProgress,
) => {
  try {
    if (detectInAppBrowser().isInApp) {
      window.open(url, "_blank");
      return;
    }
    const res1 = await fetch(url, { headers: { "fo-image-name": name } });
    const blob1 = await res1.blob();
    try {
      const shareData = {
        title: name,
        files: [new File([blob1], name, { type: mimeType })],
      };

      // Only use navigator.share on iOS
      if (
        isIOS &&
        navigator.share &&
        navigator.canShare &&
        navigator.canShare(shareData)
      ) {
        // Update store to indicate share is in progress
        if (setNavigatorShareInProgress) {
          setNavigatorShareInProgress(true);
        }

        // Wait for lock if another share is in progress
        if (navigatorShareLock) {
          // Queue this share request and wait for it to be processed
          await new Promise((resolve, reject) => {
            navigatorShareQueue.push({ shareData, resolve, reject });
          });
        } else {
          navigatorShareLock = true;
          try {
            await navigator.share(shareData);
          } finally {
            navigatorShareLock = false;
            // Process next item in queue after current share completes
            processShareQueue();
          }
        }

        // Update store to indicate share is complete
        if (setNavigatorShareInProgress) {
          setNavigatorShareInProgress(false);
        }
      } else {
        const blobNew = new Blob([blob1], { type: mimeType });
        saveAs(blobNew, name);
      }
    } catch (err) {
      // Update store to indicate share is complete (even on error)
      if (setNavigatorShareInProgress) {
        setNavigatorShareInProgress(false);
      }

      if (err.name === "AbortError") {
        throw err;
      } else {
        saveAs(blob1, name);
      }
    }
  } catch {
    // Update store to indicate share is complete (even on error)
    if (setNavigatorShareInProgress) {
      setNavigatorShareInProgress(false);
    }
    window.open(url, "_blank");
    return;
  }
};

export const handleShareImage = async (url, name, mimeType) => {
  try {
    const res1 = await fetch(url, { headers: { "fo-image-name": name } });
    const blob1 = await res1.blob();
    const shareData = {
      title: name,
      files: [new File([blob1], name, { type: mimeType })],
    };
    if (
      navigator.share &&
      navigator.canShare &&
      navigator.canShare(shareData)
    ) {
      await navigator.share(shareData);
    } else {
      await navigator.clipboard.writeText(url);
    }
  } catch (error) {
    if (error.name !== "AbortError") {
      // Fallback: copy to clipboard
      await navigator.clipboard.writeText(url);
    }
  }
};

export const getImageName = (path) => {
  if (!path) return "Unknown";
  const urlParts = path.split("/");
  return urlParts[urlParts.length - 1] || "Unknown";
};

export const dateTimeToString = (date) => {
  const dt = new Date(date);
  const offset = new Date().getTimezoneOffset();
  dt.setMinutes(dt.getMinutes() - offset);
  return dt.toLocaleDateString("en-us", {
    hour: "2-digit",
    minute: "2-digit",
    weekday: "long",
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

// Global variable to store the deferred prompt
let globalDeferredPrompt = null;

// Set up the beforeinstallprompt event listener
if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => {
    console.debug("beforeinstallprompt event fired");
    e.preventDefault();
    globalDeferredPrompt = e;
    window.deferredPrompt = e; // Also store on window for compatibility
  });

  // Listen for app installed event
  window.addEventListener("appinstalled", () => {
    console.debug("PWA was installed");
    globalDeferredPrompt = null;
    window.deferredPrompt = null;
  });
}

// Function to check if PWA is already installed
export const isPWAInstalled = () => {
  return (
    window.matchMedia("(display-mode: standalone)").matches ||
    window.navigator.standalone === true
  );
};

export const installAsPWAApp = async () => {
  // Check if PWA is already installed
  if (isPWAInstalled()) {
    return { success: false, outcome: "already_installed" };
  }

  // Check if browser supports PWA install
  const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

  console.debug("isIOS:", isIOS);
  console.debug("globalDeferredPrompt:", globalDeferredPrompt);
  console.debug("window.deferredPrompt:", window.deferredPrompt);

  // For browsers that support PWA install prompt
  if ("serviceWorker" in navigator && "PushManager" in window) {
    // Check if there's a deferred prompt available
    const deferredPrompt = globalDeferredPrompt || window.deferredPrompt;

    if (deferredPrompt) {
      try {
        console.debug("Prompting for PWA install...");
        deferredPrompt.prompt();
        const { outcome } = await deferredPrompt.userChoice;

        console.debug("Install outcome:", outcome);

        if (outcome === "accepted") {
          // Clear the deferred prompt after successful install
          globalDeferredPrompt = null;
          window.deferredPrompt = null;
          return { success: true, outcome: "accepted" };
        } else {
          return { success: false, outcome: "dismissed" };
        }
      } catch (error) {
        console.error("Error during PWA install:", error);
        return { success: false, outcome: "error", error };
      }
    } else if (isIOS) {
      // For iOS, return indication that instructions should be shown
      return { success: false, outcome: "ios_instructions_needed" };
    } else {
      // Browser supports PWA but no deferred prompt available yet
      return { success: false, outcome: "prompt_not_available" };
    }
  } else if (isIOS) {
    // For iOS devices
    return { success: false, outcome: "ios_instructions_needed" };
  } else {
    // Browser doesn't support PWA
    return { success: false, outcome: "not_supported" };
  }
};

export const isWebView = () => {
  const ua = navigator.userAgent || navigator.vendor || window.opera;
  const standalone = window.matchMedia("(display-mode: standalone)").matches;
  return (
    /(fb_iab|fbav|instagram|messenger|twitter|linkedin|whatsapp|tiktok|line|pinterest)/i.test(
      ua,
    ) ||
    (ua.includes("wv") && ua.includes("android")) || // Android WebView indicator
    !standalone
  );
};

export const detectInAppBrowser = () => {
  const ua = navigator.userAgent || navigator.vendor || window.opera;

  return {
    isFacebook: /fban|fbav|fbios|fb_iab|facebook/i.test(ua),
    isMessenger: /messenger/i.test(ua),
    isInstagram: /instagram/i.test(ua),
    isWhatsApp: /whatsapp/i.test(ua),
    isTwitter: /twitter/i.test(ua),
    isLinkedIn: /linkedin/i.test(ua),
    isTikTok: /tiktok/i.test(ua),
    isInApp:
      /(fban|fbav|fbios|fb_iab|instagram|messenger|whatsapp|linkedin|twitter|tiktok)/i.test(
        ua,
      ),
    ua,
  };
};

/**
 * Extract form data from FormData object, excluding file entries
 * @param {FormData} formData - The FormData object to extract from
 * @returns {Record<string, string>} - Object containing form data (excluding files)
 */
export const extractFormData = (formData) => {
  const formDataObj = {};
  for (const [key, value] of formData.entries()) {
    // Skip file entries
    if (value instanceof File) {
      continue;
    }
    formDataObj[key] = value.toString();
  }
  return formDataObj;
};
